import { render, staticRenderFns } from "./waitingTicket.vue?vue&type=template&id=22ba7822&"
import script from "./waitingTicket.vue?vue&type=script&lang=js&"
export * from "./waitingTicket.vue?vue&type=script&lang=js&"
import style0 from "./waitingTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports